<div class="account" [class.compact]="compact()" [class.header-mode]="header()">
  @if (isOpen()) {
    <section id="sidebar-account-panel" class="account-panel" aria-label="Account options">
      <div class="account-details"><strong>{{usuario?.name || 'User'}}</strong><span>{{usuario?.email}}</span></div>
      <a [routerLink]="profileRoute" (click)="close()"><lucide-icon [img]="icons.UserRound" [size]="17" aria-hidden="true" />My Profile</a>
      <button type="button" class="logout" (click)="logout()"><lucide-icon [img]="icons.LogOut" [size]="17" aria-hidden="true" />Logout</button>
    </section>
  }
  <button #trigger type="button" class="account-trigger" (click)="toggle()" [attr.aria-expanded]="isOpen()"
    aria-controls="sidebar-account-panel" [attr.aria-label]="'Open account menu for ' + (usuario?.name || 'User')">
    <span class="avatar" aria-hidden="true">{{getUserInitials()}}</span>
    <span class="account-summary"><strong>{{usuario?.name || 'User'}}</strong>@if (!header()) {<span>{{usuario?.email}}</span>}</span>
    <lucide-icon class="account-chevron" [img]="icons.ChevronsUpDown" [size]="16" aria-hidden="true" />
  </button>
</div>
